import classNames from 'classnames';

export const footerClasses = classNames('grid gap-16');

export const footerLinkClasses = classNames(
  'text-xs leading-[14px] text-digital-walmart-blue',
  'text-center',
  'md:w-[200px]'
);

export const footerLinksClasses = classNames(
  'list-none m-0 p-0',
  'flex flex-col items-center gap-[38px]',
  'mx-auto',
  'md:mx-0 md:flex-wrap md:h-[138px] md:gap-x-[147px] md:content-start'
);

export const footerBottomClasses = classNames('mt-8');

export const dividerClasses = classNames('m-0 border-none h-px bg-[#F4F4F4]');

export const copyrightClasses = classNames(
  'block text-center text-dark-grey-3'
);
